import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";

export default function EditMutualFund() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [fund, setFund] = useState({
        fund_name: "",
        category: "",
        returns: "",
        risk: "",
        nav: "",
        fund_manager: "",
        aum: "",
        rating: "",
        risk_level: "",
        ideal_for: "",
        lock_in_period: "",
        tax_benefit: "",
    });

    const handleChange = (e) => {
        setFund({ ...fund, [e.target.name]: e.target.value });
    };

    const getCategoryData = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/mutualfund/${id}`);
            if (res.status === 200) {
                setFund(res.data.data);
            } else {
                setFund([]);
            }
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        getCategoryData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Trim important fields
            // const trimmedFund = {
            //     ...fund,
            //     fund_name: fund.fund_name.trim(),
            //     category: fund.category.trim(),
            // };

            // ✅ Basic validations
            // if (!trimmedFund.fund_name || !trimmedFund.category) {
            //     Swal.fire({
            //         title: "Please fill all required fields",
            //         icon: "warning",
            //     });
            //     return;
            // }

            // ✅ Call update API (PUT)
            const res = await axios.put(
                `${process.env.REACT_APP_BACKEND_BASE_URL}/mutualfund/update/${id}`,
                fund
            );

            if (res.status === 200 && res.data.data) {
                Swal.fire({
                    icon: "success",
                    title: "Mutual Fund Updated Successfully",
                    timer: 1500,
                }).then(() => {
                    navigate("/mutualfund");
                });
            } else {
                Swal.fire({
                    title: "Update failed",
                    icon: "error",
                });
            }
        } catch (err) {
            console.error(err);
            Swal.fire({
                title: "Something went wrong",
                text: "Please try again later",
                icon: "error",
            });
        }
    };

    return (
        <>
            <div className="main-content">
                <div className="page-wrapper page-settings">
                    <div className="content">
                        {/* Breadcrumb and Header Section with Card Shadow */}
                        <div
                            className="mb-4"
                            style={{
                                background: "#ffffff",
                                borderRadius: "8px",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                padding: "20px",
                            }}
                        >
                                <div className="content-page-header content-page-headersplit">
                                <h5>Edit Mutual Fund</h5>
                            </div>
                            <nav
                                aria-label="breadcrumb"
                                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
                            >
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/dashboard">Dashboard</Link> /
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/mutualfund">Mutual Funds</Link> /
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Edit Mutual Fund
                                    </li>
                                </ol>
                            </nav>
                        
                        </div>

                        {/* Form Section with Card Shadow */}
                        <div
                            className="mb-4"
                            style={{
                                background: "#ffffff",
                                borderRadius: "8px",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                padding: "20px",
                            }}
                        >
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    {Object.keys(fund)
                                        .filter((key) => key !== "id" && key !== "created_at" && key !== "updated_at")
                                        .map((key) => (
                                            <div className="col-lg-4 col-md-6" key={key}>
                                                <div className="form-group">
                                                    <label style={{ marginBottom: "8px", fontWeight: 600, color: "#0D233E" }}>
                                                        {key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={`Enter ${key.replace(/_/g, " ")}`}
                                                        name={key}
                                                        value={fund[key] || ""}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                </div>

                                <div className="d-flex gap-2 mt-4">
                                    <Link to="/mutualfund" className="btn btn-cancel">
                                        <i className="fas fa-arrow-left me-2"></i>
                                        Back
                                    </Link>
                                    <button type="submit" className="btn btn-primary">
                                        <i className="fas fa-save me-2"></i>
                                        Update Mutual Fund
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
